module.exports = __webpack_public_path__ + "static/media/reddit.84fb8198.svg";